/**
 * @deprecated Use datalayer or core component instead
 *
 *  Settings class
 *
 *  This class handles all the user
 *  spesific settings
 *
 *
 *
 * @returns {cSettings}
 */
function cSettings()
{
	// default settings

	this.autoUpdate = false; // default off
	this.autoUpdateInterval = 30000; // default 30 seconds
	this.userNotificationLevel = 3; // defaults to all notifications
	this.debug = false;
	this.showTooltips = true; // show tooltip on hover elements
	this.notifyUser = true ; // display user notifications on events
	this.onlyOneFile=false; // only one file can be uploaded in once.
	this.animateFrontPageIcons=false; // animations on frontpage icons when idle
	this.animationTimout = 500000;  // set time before frontpage idle animation starts ( milliseconds)
	this.libraryLoadedAsset = [];
	this.activeApp = ""; // empty string is == false.
	this.jwplayerLoop = false; // auto loop asset

	// set methods
	this.setActiveApp = function (app) {
        this.activeApp = app;
    };
	this.setLibraryLoadedAsset = function (id, mov, image, hls)
    {
        this.libraryLoadedAsset[id] = [];

        this.libraryLoadedAsset[id]['video'] = mov;
        this.libraryLoadedAsset[id]['image'] = image;
        this.libraryLoadedAsset[id]['hls'] = hls;

    };
	this.setAnimationTimeout = function (intMilliSeconds) {
        this.animationTimout = intMilliSeconds;
    };

	this.setAnimateFrontPageIcons = function (bool) {
        this.animateFrontPageIcons = bool;
    };
	this.setOnlyOneFile = function (bool) {
        this.onlyOneFile = bool;
    };
	this.setNotifyUser = function (bool) {
        this.notifyUser = bool;
    };
	this.setShowTooltips = function (bool) {
        this.showTooltips = bool;
    };

	this.setDebug = function (bool) {
        this.debug = bool;
    };

	this.setAutoUpdate = function (bool) {
        this.autoUpdate = bool;
    };

	this.setAutoUpdateInterval = function (intMilliSeconds) {
        this.autoUpdateInterval = intMilliSeconds;
    };

	this.setUserNotificationLevel = function (level) {
        this.userNotificationLevel = level;
    };

	// get methods
	this.getActiveApp = function () {
        return this.activeApp;
    };
	this.getLibraryLoadedAsset = function (id) {
        return this.libraryLoadedAsset[id];
    };

	this.getAnimationTimeout = function () {
        return this.animationTimout;
    };


	this.getAnimateFrontPageIcons = function () {
        return this.animateFrontPageIcons;
    };

	this.getOnlyOneFile = function () {
        return this.onlyOneFile;
    };
	this.getNotifyUser = function () {
        return this.notifyUser;
    };

	this.getShowTooltips = function () {
        return this.showTooltips;
    };

	this.getDebug = function () {
        return this.debug;
    };

	this.getUserNotificationLevel = function () {
        return this.userNotificationLevel;
    };

	this.getAutoUpdate = function () {
        return this.autoUpdate;
    };

	this.getGetUpdateInterval = function () {
        return this.autoUpdateInterval;
    };



	// HELPER VARIABLE USED TO STORE TEMP CONTENT

	this.annotationShowCommentsText = [];
	this.annotationOpenCommentsContainer = [];
	this.annotationOpenWritesContainer = [];
	this.loadedAssetId = false; // set this to false before live
	this.annotationSortBy = false;
    this.annotationSort = false;
	this.annotationIdSaved = "";
	this.librarySearchFilters =[];
	this.librarySliderValues = [];
	this.reviewFilterValues = [];
	this.reviewNotificationsEmail = [];
    this.filterValues = {};
    this.searchFilters =[];
	this.activeListname = "";
	this.activeListId = null;
	this.reviewExternalAccessEmail = [];
	this.unsavedChanges = false;
	this.uploadAddedFiles= [];
	this.countAddedFiles = 0;
	this.verifyAsset = false;
	this.uploadPercentage = 0;
	this.loadAspera = true; // holds if aspera should be set up or not.
	this.helpText = [];
	this.uploadValidateWheelElement = [];
	this.arrLoadedKendoGrids = [];
	this.saveFrom = false;
	this.createNewMetaVariables = [];
	this.newlyAddedMetaTags = [];
	this.callBackFunctionCall = [];
	this.libraryLineViewColumns  =[];
	this.libraryViewMode = false;
	this.addedAssetsToDestinations = [];
	this.customerConfigKeys = [];
	this.assetTimeCodeStart=0;
	this.useCoreFunction = false;
	this.assetStatus = "";
	this.assetMimeType = "video";
	this.sportClipListDefines = [];
	this.totalCount = 0; // total count of files added for upload
	this.highestAddedId = 0; // the highest id for added files to upload.
	this.eventStartTime = 0; // first half, second half etc
	this.eventKickOfTime = 0; // start of event in file
	this.activeSportListId = []; // holds wich list is active. both for event and clip
	this.assetLengthInSeconds = 0; // length of loaded asset in seconds
	this.listType = "eventlist"; // list type
	this.showAllListsChecked = []; // holds if show all list are checked.
    this.nActiveSmartSearchId = null; // Stores the active smartsearch for a user

	this.activeListData = null;

	this.assetFileData = [];
	this.arrBreakLengths = [];

	this.nPersonIdEdit = 0;
	this.assetIngestStatus = "";

	this.firstRevisionAssetId = null;
	this.nLoadedClipEventStart = 0; // event start for loaded clip. eg 45 for second half
    this.nLoadedClipEventKickOfTime = 0 ; // kick of time for first event (offset)
    this.aActiveClipListData = [];

    this.nCurrentPageSize = 0;

    this.activeTagFileForUploadId = 0;


    this.nGeneralTimeCodeStartMilliSeconds = 0;

    this.strSelectedTemplate = "";

    this.loginFromAppIcon = "";

    this.arrDataParams = {};


    this.arrSaveGroupSettingsFilters = {};
	// remove
	this.removeUploadAddedFiles = function (nElementId) {
        if (nElementId) {
            delete this.uploadAddedFiles[nElementId];
            this.countAddedFiles--;
        }
        else {
            this.uploadAddedFiles = [];
            this.countAddedFiles = 0;
        }
    };


	// set functions
    this.setActiveSmartSearchId = function(nSmartSearchId)
    {
        this.nActiveSmartSearchId = nSmartSearchId;
    };

    this.setSaveGroupSettingsFilters = function(arrFilters)
    {
        this.arrSaveGroupSettingsFilters = arrFilters;
    };
    this.setDataParams = function(arrParams)
    {
        this.arrDataParams = arrParams;
    };
    this.setSelectedTemplate = function(strTemplate)
    {
        this.strSelectedTemplate = strTemplate
    };

    this.setGeneralTimeCodeStartMilliSeconds = function(nTimeCode)
    {
        this.nGeneralTimeCodeStartMilliSeconds = nTimeCode*1000;
    };

    this.setCurrentPageSize = function(nPageSize)
    {
        this.nCurrentPageSize = nPageSize;
    };

    this.setLoginFromAppIcon = function(strAppName)
    {
        this.loginFromAppIcon = strAppName;
    };
    this.setActiveTagFileForUploadId = function (nClickedId) {
        this.activeTagFileForUploadId = nClickedId;
    };
    this.setActiveClipListData = function (objClipListData) {
        this.aActiveClipListData = objClipListData;
    };
    this.setLoadedClipEventKickOfTime = function (nKickOfTime) {
        this.nLoadedClipEventKickOfTime = nKickOfTime;
    };

    this.setLoadedClipEventStart = function (nThisClipEventStart) {
        this.nLoadedClipEventStart = nThisClipEventStart;
    };
	this.setFirstRevisionAssetId = function (nId) {
        this.firstRevisionAssetId = nId;
    };

	this.setAssetIngestStatus = function (strStatus) {
        this.assetIngestStatus = strStatus;
    };
	this.setNPersonIdEdit = function (nId) {
        this.nPersonIdEdit = nId;
    };
	this.setArrBreakLengths = function (nPart, nLengthInSeconds) {
        this.arrBreakLengths[nPart] = nLengthInSeconds;
    };

	this.setAssetFileData = function (rtmptFile, hlsFile, aspectratio) {
        this.assetFileData['rtmptfile'] = rtmptFile;
        this.assetFileData['hlsfile'] = hlsFile;
        this.assetFileData['aspectratio'] = aspectratio;
    };
	this.setActiveListData = function (objData) {
        this.activeListData = objData;
    };
	this.setShowAllListsChecked = function (bChecked, strListType) {
        this.showAllListsChecked[strListType] = bChecked;
    };

	this.setListType = function (strListType) {
        this.listType = strListType;
    };
	this.setAssetLengthInSeconds = function (nAssetLengthSeconds) {
        this.assetLengthInSeconds = nAssetLengthSeconds;
    };
	this.setActiveSportListId = function (nListId, strListType) {
        this.activeSportListId[strListType] = nListId;
    };
	this.setEventKickOfTime = function (nKickOfTime) {
        this.eventKickOfTime = nKickOfTime;
    };
	this.setEventStartTime = function (nEventStartTime) {
        this.eventStartTime = nEventStartTime;
    };
    this.setPartOffset = function (nPartOffset) {
        this.partOffset = nPartOffset;
    };
	this.setHighestAddedId = function (nHighId) {
        this.highestAddedId = nHighId;
    };
	this.setTotalCount = function (nCount) {
        this.totalCount = nCount;

    };
	this.setSportClipListDefines = function (strElement, nValue) {
        this.sportClipListDefines[strElement] = nValue;
    };
	this.setAssetMimeType = function (strMimeType) {
        this.assetMimeType = strMimeType;
    };
	this.setAssetStatus = function (strStatus) {
        this.assetStatus = strStatus;
    };
	this.setUseCoreFunction = function (value) {
        this.useCoreFunction = value;
    };

	this.setAssetTimeCodeStart = function (nTimeCodeStart) {

        this.assetTimeCodeStart = nTimeCodeStart;
    };

	this.setCustomerConfigKeys = function (arrKeys) {
        this.customerConfigKeys = arrKeys;
    };
	this.setCustomerConfigKeysElem = function (key, value) {
        this.customerConfigKeys[key] = value;
    };

	this.setAddedAssetsToDestinations = function (nDestinationId, nAssetId, strAssetTitle, strAssetImageUrl) {
        if (typeof(this.addedAssetsToDestinations[nDestinationId] ) === "undefined") {
            this.addedAssetsToDestinations[nDestinationId] = [];

        }
        var nCounter = this.addedAssetsToDestinations[nDestinationId].length;

        this.addedAssetsToDestinations[nDestinationId][nCounter] = [];

        this.addedAssetsToDestinations[nDestinationId][nCounter]['assetId'] = nAssetId;
        this.addedAssetsToDestinations[nDestinationId][nCounter]['assetTitle'] = strAssetTitle;
        this.addedAssetsToDestinations[nDestinationId][nCounter]['assetImageUrl'] = strAssetImageUrl;
    };

	this.setCountAddedFiles = function (nCount) {
        this.countAddedFiles = nCount;
    };

	this.setLibraryViewMode = function (viewMode) {
        this.libraryViewMode = viewMode;
    };
	this.setLibraryLineViewColumns = function (columns) {
        this.libraryLineViewColumns = columns;
    };


	this.setCallBackFunctionCall = function (fnFunctionCall, arrParam) {

        this.callBackFunctionCall['functionCall'] = fnFunctionCall;
        this.callBackFunctionCall['params'] = [];
        this.callBackFunctionCall['params'] = arrParam;

    };

	this.setNewlyAddedMetaTags = function (metaTag, value) {
        if (typeof(this.newlyAddedMetaTags[metaTag] ) === "undefined") {
            this.newlyAddedMetaTags[metaTag] = [];
        }
        this.newlyAddedMetaTags[metaTag][value] = value;

    };

	this.setCreateNewMetaVariables = function (strSelectedId, strSelectedMetaTag) {
        this.createNewMetaVariables['id'] = strSelectedId;
        this.createNewMetaVariables['metaTag'] = strSelectedMetaTag;
    };




	this.setSaveFrom = function (strSaveFrom) {
        this.saveFrom = strSaveFrom;
    };

	this.setLoadedKendoGrids = function (strId) {

        this.arrLoadedKendoGrids[strId] = true;
    };

	this.setUploadValidateWheelElement = function (strElement, bValue) {
        if (typeof(this.uploadValidateWheelElement[strElement] ) === "undefined")
            this.uploadValidateWheelElement[strElement] = [];
        this.uploadValidateWheelElement[strElement] = bValue;
    };
	this.setHelpText = function (strElement, strText) {
        if (typeof(this.helpText[strElement] ) === "undefined")
            this.helpText[strElement] = [];
        this.helpText[strElement] = strText;
    };
	this.setLoadAspera = function (bool) {
        this.loadAspera = bool;
    };

	this.setUploadPercentage = function (percentage) {
        this.uploadPercentage = percentage;
    };
	this.setVerifyAsset = function (bool) {
        this.verifyAsset = bool;
    };

	this.setUploadAddedFiles = function (count, key, name) {
        if (typeof(this.uploadAddedFiles[count]) === "undefined")
            this.uploadAddedFiles[count] = [];
        this.uploadAddedFiles[count][key] = name;


    };

	this.setUnsavedChanges = function (status) {
        this.unsavedChanges = status;
    };

	this.setActiveListId = function (id) {
        this.activeListId = id;
    };
	this.setActiveListname = function (name) {
        this.activeListname = name;
    };

	this.setReviewExternalAccessEmail = function (email) {
        if (email) {
            var count = this.reviewExternalAccessEmail.length;
            this.reviewExternalAccessEmail[count] = email;
        }
        else {
            this.reviewExternalAccessEmail = [];
        }
    };

	this.setReviewNotificationsEmail = function (email) {
        if (email) {
            var count = this.reviewNotificationsEmail.length;
            this.reviewNotificationsEmail[count] = email;
        }
        else {
            this.reviewNotificationsEmail = [];
        }
    };

	this.setLibrarySearchFiltersType = function (filter) {

        this.librarySearchFilters = filter;
    };

	this.setReviewFilterValues = function (filter) {
        this.reviewFilterValues = filter;

    };

    this.setFilterValues = function (filter) {
        this.filterValues = filter;
    };

    this.setFilterValuesSearchString = function (searchString) {
        this.filterValues['search_string'] = searchString;
    };

	this.setReviewFilterValuesSearchString = function (searchString) {
        this.reviewFilterValues['search_string'] = searchString;
    };

	this.setLibrarySliderValues = function (values) {
        this.librarySliderValues = values;
    };

	this.setLibrarySearchFilterString = function (searchString) {
        this.librarySearchFilters['search_string'] = searchString;
    };

	this.setLibrarySearchFiltersTime = function (start, end) {
        this.librarySearchFilters['start_time'] = start;
        this.librarySearchFilters['end_time'] = end;

    };


	this.setAnnotationIdSaved = function (id) {
        this.annotationIdSaved = id;
    };
	this.setAnnotationSortBy = function (sort_by) {
        this.annotationSortBy = sort_by;
    };

    this.setAnnotationSort = function (sort) {
        this.annotationSort = sort;
    };

	this.setLoadedAssetId = function (id) {
        this.loadedAssetId = parseInt(id);
    };
	this.setAnnotationShowCommentsText = function (value, id) {

        this.annotationShowCommentsText[id] = value;
    };

	this.setAnnotationOpenCommentsContainer = function (value, id) {
        this.annotationOpenCommentsContainer[id] = value;
    };

	this.setAnnotationOpenWritesContainer = function (value, id) {
        this.annotationOpenWritesContainer[id] = value;
    };


	// get
    this.getActiveSmartSearchId = function()
    {
        return this.nActiveSmartSearchId;
    };

    this.getSaveGroupSettingsFilters = function()
    {
        return this.arrSaveGroupSettingsFilters;
    };
    this.getDataParams = function()
    {
        return this.arrDataParams;
    };
    this.getSelectedTemplate = function()
    {
        return this.strSelectedTemplate;
    };
    this.getGeneralTimeCodeStartMilliSeconds = function()
    {
        return this.nGeneralTimeCodeStartMilliSeconds;
    };

    this.getCurrentPageSize  =function()
    {
        return this.nCurrentPageSize;
    };

    this.getLoginFromAppIcon = function()
    {
         return loginFromAppIcon;
    };

    this.getActiveTagFileForUploadId = function () {
        return this.activeTagFileForUploadId;
    };

    this.getActiveClipListData = function () {
        return this.aActiveClipListData;
    };

    this.getLoadedClipEventKickOfTime = function () {
        return this.nLoadedClipEventKickOfTime;
    };
    this.getLoadedClipEventStart = function () {
        return this.nLoadedClipEventStart;
    };

	this.getFirstRevisionAssetId = function () {
        return this.firstRevisionAssetId;
    };

	this.getAssetIngestStatus = function () {
        return this.assetIngestStatus;
    };
	this.getNPersonIdEdit = function () {
        return this.nPersonIdEdit;
    };

	this.getArrBreakLengths = function (nPart) {
        return this.arrBreakLengths[nPart];
    };


	this.getAssetFileData = function () {
        return this.assetFileData;

    };
	this.getActiveListData = function () {
        return this.activeListData;
    };
	this.getActiveListDataEvent = function (nEvent) {
        return this.activeListData[nEvent];
    };
	this.getShowAllListsChecked = function (strListType) {
        return this.showAllListsChecked[strListType];
    };

	this.getListType = function () {
        return this.listType;
    };
	this.getAssetLengthInSeconds = function () {
        return this.assetLengthInSeconds;
    };

	this.getActiveSportListId = function (strListType) {
        return this.activeSportListId[strListType];
    };
	this.getEventKickOfTime = function () {
        return this.eventKickOfTime;
    };
	this.getEventStartTime = function () {
        return this.eventStartTime;
    };
    this.getPartOffset = function () {
        return this.partOffset;
    };
	this.getHighestAddedId = function () {
        return this.highestAddedId;
    };

	this.getTotalCount = function () {
        return this.totalCount;

    };

	this.getSportClipListDefines = function () {
        return this.sportClipListDefines;
    };

	this.getAssetMimeType = function () {
        return this.assetMimeType;
    };

	this.getAssetStatus = function () {
        return this.assetStatus;
    };

	this.getUseCoreFunction = function () {
        return this.useCoreFunction;
    };
	this.getCustomerConfigKeys = function (key) {
        return this.customerConfigKeys[key];
    };

	this.getAssetTimeCodeStart = function () {
        return this.assetTimeCodeStart;
    };

	this.getAddedAssetsToDestinations = function (id) {
        return this.addedAssetsToDestinations[id];
    };
	this.getCountAddedFiles = function () {
        return this.countAddedFiles;
    };

	this.getLibraryViewMode = function () {
        return this.libraryViewMode;
    };

	this.getLibraryLineViewColumns = function () {
        return this.libraryLineViewColumns;
    };

	this.getCallBackFunctionCall = function (key) {
        return this.callBackFunctionCall[key];
    };


	this.getNewlyAddedMetaTags = function () {
        return this.newlyAddedMetaTags;
    };
	this.getCreateNewMetaVariables = function (key) {
        return this.createNewMetaVariables[key];
    };

	this.getSaveFrom = function () {
        return this.saveFrom;
    };


	this.getLoadedKendoGrids = function (strElement) {

        return this.arrLoadedKendoGrids[strElement];
    };


	this.getUploadValidateWheelElement = function (strElement) {
        return this.uploadValidateWheelElement[strElement];
    };


	this.getHelpText = function (strElement) {
        return this.helpText[strElement];
    };
	this.getLoadAspera = function (bool) {
        return this.loadAspera;
    };



	this.getUploadPercentage = function () {
        return this.uploadPercentage;
    };
	this.getVerifyAsset = function () {
        return this.verifyAsset;
    };

	this.getUploadAddedFiles = function (id) {
        if (id)
            return this.uploadAddedFiles[id];
        else
            return this.uploadAddedFiles;
    };
	this.getUnsavedChanges = function () {
        return this.unsavedChanges;
    };


	this.getReviewFilterValuesSearchString = function () {
        return this.reviewFilterValues['search_string'];

    };

	this.getReviewExternalAccessEmail = function (email) {
        return    this.reviewExternalAccessEmail;
    };

    this.getFilterValuesSearchString = function () {
        return this.filterValues['search_string'];

    };

    this.getFilterValues = function () {
        return this.filterValues;

    };

	this.getActiveListId = function () {
        return this.activeListId;
    };

	this.getActiveListname = function () {
        return this.activeListname;
    };


	this.getReviewNotificationsEmail = function () {
        return this.reviewNotificationsEmail;
    };



	this.getReviewFilterValues = function () {
        return this.reviewFilterValues;

    };


	this.getlibrarySliderValues = function (values) {
        return this.librarySliderValues;
    };

	this.getLibrarySearchFilters = function () {
        return this.librarySearchFilters;

    };


	this.getAnnotationIdSaved = function () {
        return this.annotationIdSaved;
    };

	this.getAnnotationSortBy = function () {

        if (this.annotationSortBy === "reviewAnnotationsSortMarkIn")
            return "MarkIn";
        else if (this.annotationSortBy === "reviewAnnotationsSortMarkOut")
            return "MarkOut";
        else if (this.annotationSortBy === "reviewAnnotationsSortCode")
            return "Code";
        else if (this.annotationSortBy === "reviewAnnotationsSortTimeStamp")
            return "Timestamp";
        else if (this.annotationSortBy === "reviewAnnotationsSortUser")
            return "User";
        else
            return false;
    };

    this.getAnnotationSort = function () {
        return this.annotationSort;
    };

	this.getLoadedAssetId = function () {
        return this.loadedAssetId;
    };

	this.getAnnotationOpenWritesContainer = function (id) {
        if (id)
            return this.annotationOpenWritesContainer[id];
        else
            return this.annotationOpenWritesContainer;
    };




	this.getAnnotationOpenCommentsContainer = function (id) {
        if (id)
            return this.annotationOpenCommentsContainer[id];
        else
            return this.annotationOpenCommentsContainer;
    };



	this.getAnnotationShowCommentsText = function (id) {

        return this.annotationShowCommentsText[id];
    };

	// delete
	this.removeAddedAssetFromDestination = function(nDestinationId,nAssetId)
	{

		for (var arrElementId in this.addedAssetsToDestinations[nDestinationId])
		{
			if(parseInt(this.addedAssetsToDestinations[nDestinationId][arrElementId]['assetId']) === nAssetId)
			{
				delete this.addedAssetsToDestinations[nDestinationId][arrElementId];
				len = this.addedAssetsToDestinations[nDestinationId].length;
				// removed undefined elements
				for(i = 0; i < len; i++ )
				    this.addedAssetsToDestinations[nDestinationId][i] && this.addedAssetsToDestinations[nDestinationId].push(this.addedAssetsToDestinations[nDestinationId][i]);  // copy non-empty values to the end of the this.addedAssetsToDestinations[nDestinationId]ay
				this.addedAssetsToDestinations[nDestinationId].splice(0 , len);  // cut the this.addedAssetsToDestinations[nDestinationId]ay and leave only the non-empty values
			}
		}

	}

}

/**
 * @deprecated
 *   Use components instead
 * @type {cSettings}
 */
mediaBankSettings = new cSettings();